var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.displayStatus
    ? _c("span", { staticClass: "custom-badge", class: _vm.badgeColor }, [
        _vm._v("\n    " + _vm._s(_vm.displayStatus) + "\n"),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }